import loadable from '@loadable/component';

export const LazyGuestSiteBody = loadable(() => import(/* webpackChunkName: "content/guest/site/body" */ './GuestSiteBody'));
